import React from 'react';

interface NumberOfQuestionsProps {
  numberOfQuestionsInput: string;
  onInputChange: (value: string) => void;
  onBlur: (value: string) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  maxQuestions?: number;
}

const NumberOfQuestions: React.FC<NumberOfQuestionsProps> = ({
  numberOfQuestionsInput,
  onInputChange,
  onBlur,
  onKeyDown,
  maxQuestions = 60
}) => {
  return (
    <div className="mb-4">
      <label className="form-label fw-semibold">
        <i className="fas fa-hashtag me-2 text-primary"></i>
        Number of Questions
      </label>
      <input
        type="number"
        className="form-control form-control-lg"
        style={{ borderRadius: '12px' }}
        min="1"
        max={maxQuestions}
        value={numberOfQuestionsInput}
        onChange={(e) => onInputChange(e.target.value)}
        onBlur={(e) => onBlur(e.target.value)}
        onKeyDown={onKeyDown}
      />
      <div className="form-text">
        Select between 1 and {maxQuestions} questions
      </div>
    </div>
  );
};

export default NumberOfQuestions;